import { iframeAppBiLoggerFactory } from '@wix/iframe-app-bi-logger';

import {
  getInstanceId,
  getUUId,
  getBiToken,
  getCompId,
  getMetaSiteId,
  getViewMode,
  getVisitorId,
} from '../wixServices';

let logger;
const Wix = window.Wix;

const reportSendService = (sendService) => logger.log(sendService);

const initLogger = () => {
  logger = iframeAppBiLoggerFactory(window.Wix, {
    endpoint: 'wixlabs-ugc',
  })
    .setEvents({})
    .updateDefaults({
      src: 63,
      comp_id: Wix.Utils.getCompId(),
      hosting: 'wixlabs-ugc',
    })
    .logger();
};
initLogger();

const biToken = getBiToken();

const buildData = (data) => {
  const compId = getCompId();

  const generalRequest: any = {
    src: '63',
    biToken,
    app_id: '129acb44-2c8a-8314-fbc8-73d5b973a88f',
  };
  if (Wix.Utils.getViewMode() === 'site') {
    generalRequest.instance_id = getInstanceId();
    generalRequest.comp_id = compId;
    generalRequest.visitor_id = getVisitorId();
    generalRequest.msid = getMetaSiteId();
  } else {
    // Editor.
    generalRequest.app_site_id = getInstanceId();
    generalRequest.uuid = getUUId();
    generalRequest.instance_id = window.Wix.Utils.getOrigCompId();
  }

  Object.assign(generalRequest, data);

  return generalRequest;
};

const convertToURLParams = (data) =>
  Object.keys(data)
    .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`)
    .join('&');

/**
 * @param {*object} data
 * @description Trigger event to wix Bi.
 * @returns {*void}
 */
export function triggerBIEvent(data) {
  let url = '';
  if (Wix.Utils.getViewMode() === 'site') {
    reportSendService(data);
  }
  if (Wix.Utils.getViewMode() === 'editor') {
    url = 'https://frog.wix.com/wixlabs-users';

    if (biToken && typeof biToken === 'string') {
      const date = new Date();
      const mergedData = buildData(data);
      const urlParams = convertToURLParams(mergedData);
      const completeUrl = `${url}?${urlParams}&${date.getTime()}`;
      const img = new Image();
      img.src = completeUrl;
    }
  }
}
